import React, { useState, useEffect } from 'react';
import screenLogin from '../assets/screen-login.jpg';
import screenHome from '../assets/screen-home.png';
import screenSearch from '../assets/screen-search.png';
import screenDoctors from '../assets/screen-doctors.png';
import screenBooking from '../assets/screen-booking.png';
import screenBookings from '../assets/screen-bookings.png';
import screenFilter from '../assets/screen-filter.png';
import screenLabs from '../assets/screen-labs.png';
import screenNotification from '../assets/screen-notification.png';
import screenReviews from '../assets/screen-reviews.png';

function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);

  const sliderData = [
    {
      id: 1,
      image: screenLogin,
      title: 'Secure Access',
      desc: 'Log in safely and securely to manage your personal health information.',
      icon: 'bi-shield-lock'
    },
    {
      id: 2,
      image: screenHome,
      title: 'Dynamic Dashboard',
      desc: 'View upcoming appointments and access quick services from your home screen.',
      icon: 'bi-house'
    },
    {
      id: 3,
      image: screenSearch,
      title: 'Search Appointments',
      desc: 'Easily find the right specialists and consultation fees that fit your needs.',
      icon: 'bi-search'
    },
    {
      id: 4,
      image: screenDoctors,
      title: 'Top Rated Doctors',
      desc: 'Browse and select from a compiled list of top-rated specialized doctors near you.',
      icon: 'bi-star'
    },
    {
      id: 5,
      image: screenBooking,
      title: 'Instant Booking',
      desc: 'Select preferred available slots and instantly schedule your doctor consultation.',
      icon: 'bi-calendar2-check'
    },
    {
      id: 6,
      image: screenBookings,
      title: 'My Bookings',
      desc: 'Track and manage your upcoming, pending, and past appointments with ease.',
      icon: 'bi-journal-check'
    },
    {
      id: 7,
      image: screenFilter,
      title: 'Advanced Filtering',
      desc: 'Quickly narrow down your search by location, specialty, gender, and experience factor.',
      icon: 'bi-funnel'
    },
    {
      id: 8,
      image: screenLabs,
      title: 'Comprehensive Labs',
      desc: 'Easily find and book essential laboratory tests securely through the app.',
      icon: 'bi-droplet'
    },
    {
      id: 9,
      image: screenNotification,
      title: 'Instant Notifications',
      desc: 'Keep track of your payments, upcoming appointments, and health alerts seamlessly.',
      icon: 'bi-bell'
    },
    {
      id: 10,
      image: screenReviews,
      title: 'Patient Reviews',
      desc: 'Read authentic patient reviews and ratings to make informed decisions about your care.',
      icon: 'bi-chat-quote'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % sliderData.length);
    }, 4000); // Auto slide every 4 seconds
    return () => clearInterval(interval);
  }, [sliderData.length]);

  return (
    <section className="hero-section" id="home">
      <div className="container-lg">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <h1 className="hero-title">
              {/* Your Health, <br /> */}
              {/* Our <span className="text-primary-custom">Priority</span> */}
              Skip the <span className="text-primary-custom">Queue</span>
              <br />
              Get Care <span className="text-primary-custom">Faster</span>
            </h1>
            <p className="hero-subtitle">
              Search doctors, book appointments, and access healthcare services instantly with FastInQueue.
            </p>
            <div className="d-flex flex-wrap mb-4">
              <a href="#" className="store-btn google-play-btn">
                <i className="bi bi-google-play"></i>
                <div className="store-btn-text">
                  <span className="store-btn-sub">GET IT ON</span>
                  <span className="store-btn-main">Google Play</span>
                </div>
              </a>
              <a href="#" className="store-btn app-store-btn">
                <i className="bi bi-apple"></i>
                <div className="store-btn-text">
                  <span className="store-btn-sub">Download on the</span>
                  <span className="store-btn-main">App Store</span>
                </div>
              </a>
            </div>
            <p className="small text-muted d-none">
              Want to use hospital portal? <a href="#" className="text-primary-custom text-decoration-none fw-semibold">Login to FastInQueue</a>
            </p>
          </div>
          <div className="col-lg-6">
            <div className="hero-image-wrapper text-center position-relative d-flex justify-content-center align-items-center" style={{ minHeight: '600px' }}>

              {sliderData.map((slide, index) => (
                <div
                  key={slide.id}
                  style={{
                    position: index === activeIndex ? 'relative' : 'absolute',
                    opacity: index === activeIndex ? 1 : 0,
                    visibility: index === activeIndex ? 'visible' : 'hidden',
                    transition: 'opacity 0.8s ease-in-out, visibility 0.8s',
                    zIndex: index === activeIndex ? 2 : 0,
                    width: '100%'
                  }}
                >

                  {/* iPhone CSS Mockup */}
                  <div className="iphone-mockup mx-auto" style={{ marginBottom: '30px' }}>
                    <div className="iphone-screen">
                      <div className="iphone-notch"></div>
                      <img src={slide.image} alt={slide.title} className="w-100 h-100 object-fit-cover" />
                    </div>
                  </div>

                  <div className="floating-card" style={{
                    opacity: index === activeIndex ? 1 : 0,
                    transform: index === activeIndex ? 'translateY(-50%) scale(1)' : 'translateY(-45%) scale(0.95)',
                    transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                  }}>
                    <div className="d-flex align-items-center mb-2">
                      <div className="me-2 text-primary-custom">
                        <i className={`bi ${slide.icon} fs-4`}></i>
                      </div>
                      <h5 className="mb-0">{slide.title}</h5>
                    </div>
                    <p className="text-start">
                      {slide.desc}
                    </p>
                  </div>
                </div>
              ))}

              {/* Slider Dots */}
              <div className="position-absolute d-flex gap-2" style={{ bottom: '5px', zIndex: 10, }}>
                {sliderData.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className="btn p-0 rounded-circle"
                    style={{
                      width: index === activeIndex ? '24px' : '10px',
                      height: '10px',
                      borderRadius: '10px',
                      backgroundColor: index === activeIndex ? 'var(--primary-color)' : '#cbd5e1',
                      border: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
